import styled from 'styled-components';

import { hexToRgba } from '~/common/utils/hex-to-rgba';
import { SPACING } from '~/common/constants/spacing';
import { RADIUS } from '~/common/constants/border-radius';

export const VersionButtonContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${SPACING._6};
  width: 100%;
  padding: ${SPACING._8};
  border: none;
  border-radius: ${RADIUS._4};
  background-color: ${({ theme }) => theme.transparent};
  cursor: pointer;
  transition: 200ms;

  span {
    transition: 200ms;
  }

  &:hover {
    background-color: ${({ theme }) => hexToRgba(theme.primary, 0.1)};

    span,
    svg {
      color: ${({ theme }) => theme.primary};
    }
  }
`;
